<template lang="html">
  <div class="vip-swiper">
    <swiper :options="swiperOptions">
      <swiper-slide
        :style="style"
        v-for="(item, index) in list"
        :key="index"
        :class="{'swiper-no-swiping' :touchVisible}"
        class="vip-swiper-slide">
        <img :src="item" :style="style" alt="">
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { StyleTransfer } from "../../lib/styleTransfer";
const styleTransfer = new StyleTransfer(750, 10)
export default {
  name: 'VipSwiper',
  props: {
    swiperOptions: {
      type: Object,
      default: {
        slidesPerView: 'auto',
        slidesOffsetAfter: 38,
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        autoplayDisableOnInteraction: false
      },
    },
    list: {
      type: Array,
      default: []
    },
    width: {
      type: Number,
      default: 0
    },
    margin: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: 'rem'
    },
    nameList: {
      type: Array,
      default: []
    },
    touchVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style () {
      const result = {}
      styleTransfer.parseStyle(result, this.width, 'width', this.unit)
      if (this.inlineBlock) {
        result.display = 'inline-block'
      }
      return result
    },
  },
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.vip-swiper {
  /*padding-left: rem(20);*/
  &-slide {
    margin-right: rem(20);
  }
}
</style>
